// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/home/dispatchbutler/data/dispatchbutler/frontend/src/models/app-settings';
import model_3 from '/home/dispatchbutler/data/dispatchbutler/frontend/src/models/store-config';
import model_4 from '/home/dispatchbutler/data/dispatchbutler/frontend/src/.umi-production/plugin-initialState/@@initialState';
import model_2 from '/home/dispatchbutler/data/dispatchbutler/frontend/src/models/clockGate';

export const models = {
model_1: { namespace: 'app-settings', model: model_1 },
model_3: { namespace: 'store-config', model: model_3 },
model_4: { namespace: '@@initialState', model: model_4 },
model_2: { namespace: 'clockGate', model: model_2 },
} as const
